import { useIsMobile } from 'hooks';
import { useAppSelector } from 'store/hooks';

import { AcquiringsCards } from '../acquirings-cards';
import { FormType } from '../form-type';
import { PaymentWrapper } from '../payment-wrapper';

const PaymentBox = () => {
  const { acquiring } = useAppSelector((state) => state.payment);
  const { isMobile } = useIsMobile();

  return !isMobile ? (
    <PaymentWrapper className="bg-base-gray-700 items-center flex">
      {acquiring ? <FormType /> : <AcquiringsCards />}
    </PaymentWrapper>
  ) : null;
};

export { PaymentBox };
